import React from 'react'
import './style/Timeline.css'
import IMG from '../resources/else/peterzwingler2(60von171).jpg'

const milestones = [
  {
    year: '2018',
    text: 'Kaffeebrennerei Zwingler wird gegründet – mit dem Wunsch, ehrlichen, nachhaltig produzierten Kaffee zu rösten.'
  },

  {
    year: '2023',
    text: 'Wir werden bio-zertifiziert – ein weiterer Schritt in Richtung Qualität und Verantwortung.'
  },
  {
    year: 'Heute',
    text: 'Unsere Community wächst – gemeinsam mit euch entwickeln wir uns ständig weiter.'
  }
]

const Timeline = () => {
  return (
    <div className='timeline-container'>
      {/* Bildbereich */}
      <div className='timeline-image'>
        <img src={IMG} alt='Peter Zwingler' />
      </div>

      {/* Timeline-Bereich */}
      <div className='timeline'>
        {milestones.map((milestone, index) => (
          <div key={index} className='timeline-item'>
            <div className='timeline-year'>{milestone.year}</div>
            <div className='timeline-content'>{milestone.text}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Timeline
